import { GetPaymentTradesHistoryApi } from "@/features/accounts/payment/scraping/services/get-trades-history-api";
import { GetPaymentTradesHistoryRequestModel } from "@/features/accounts/payment/scraping/services/get-trades-history-model";

/// MoneyLook取込履歴取得処理
export class GetPaymentTradesHistoryService {
  private getPaymentTradesHistoryApi = new GetPaymentTradesHistoryApi();

  /**
   * MoneyLook取込履歴取得API実行
   */
  public async getPaymentTradesHistory(param: GetPaymentTradesHistoryRequestModel) {
    return await this.getPaymentTradesHistoryApi.getPaymentTradesHistory(param);
  }
}
